import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

/**
 * Ask-VAULT hero input for the Concierge dashboard.
 * Deep-links to /ai with the typed prompt pre-filled via URL state.
 */
export default function AskVaultHero() {
    const nav = useNavigate();
    const [q, setQ] = useState("");
    const go = (prompt) => {
        const target = prompt || q.trim();
        if (!target) { nav("/ai"); return; }
        // Pass the prompt through location state; VaultIntelligence reads
        // it on mount and dispatches the message.
        nav("/ai", { state: { autoAsk: target } });
    };
    const CHIPS = [
        "What needs my attention?",
        "What payments are coming up?",
        "Which subscriptions renew this month?",
        "Which documents expire soon?",
    ];
    return (
        <div className="rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 via-white to-stone-50 p-5"
             data-testid="ask-vault-hero">
            <div className="flex items-center gap-1.5 mb-2">
                <Sparkles size={13} className="text-amber-700" />
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-800">Ask VAULT · AI</span>
            </div>
            <div className="relative">
                <input
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") go(); }}
                    placeholder="Ask VAULT about your financial world…"
                    data-testid="ask-vault-hero-input"
                    className="w-full pl-4 pr-14 py-3 rounded-full border border-stone-200 focus:border-amber-400 focus:outline-none text-[14px] bg-white"
                />
                <button
                    onClick={() => go()}
                    data-testid="ask-vault-hero-go"
                    className="absolute right-1.5 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-stone-900 hover:bg-stone-800 text-white flex items-center justify-center"
                >
                    <ArrowRight size={14} />
                </button>
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5" data-testid="ask-vault-chips">
                {CHIPS.map((c) => (
                    <button key={c} onClick={() => go(c)}
                            className="text-[11.5px] px-2.5 py-1 rounded-full bg-white border border-stone-200 hover:border-amber-400 hover:bg-amber-50 text-stone-700">
                        {c}
                    </button>
                ))}
            </div>
        </div>
    );
}
